/* eslint-disable @typescript-eslint/no-explicit-any */
import { orderBy } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Modal, Popover, tokens } from '@treams/treams-ui';

import { AnalyticsMetricContainer } from './AnalyticsMetric';
import { AnalyticsNumberMetric } from './AnalyticsNumberMetric';

const AnalyticsConversationsMetricMore = styled.button`
	width: 100%;
	height: 30px;
	color: ${tokens.text.secondary};
	background-color: transparent;
	line-height: 40px;

	:hover {
		color: ${tokens.text.primary};
	}

	:active {
		opacity: 0.5;
	}
`;

function AnalyticsConversationsMetricList(props: {
	metricGroupID: string;
	metric: graphql.AnalyticsConversationsMetric;
	totalUsers: number;
	limit?: number;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	return (
		<>
			{orderBy(props.metric.templates, (template) => template.value, 'desc')
				.slice(0, props.limit ?? 1000)
				.map((template, index) => (
					<AnalyticsMetricContainer key={index} my={1}>
						<AnalyticsNumberMetric
							metricGroupID={props.metricGroupID}
							metric={
								{
									id: props.metric.id,
									...template,
									threshold: props.metric.threshold,
								} as any
							}
							details={localize(template.template.title).text}
							subtitle={index === 0 ? t('analytics.metrics.conversation.topTemplate') : undefined}
							totalUsers={props.totalUsers}
						/>
					</AnalyticsMetricContainer>
				))}
		</>
	);
}

export function AnalyticsConversationsMetric(props: {
	metricGroupID: string;
	metric: graphql.AnalyticsConversationsMetric;
	totalUsers: number;
}) {
	const { t } = useTranslation();
	const [modalVisible, setModalVisible] = useState(false);

	return (
		<>
			{modalVisible && (
				<Popover visible center>
					<Modal height="auto">
						<Modal.Header
							title={t('analytics.metrics.conversation.modal.title')}
							onClose={() => setModalVisible(false)}
						/>

						<Modal.Contents>
							<AnalyticsConversationsMetricList
								metricGroupID={props.metricGroupID}
								metric={props.metric}
								totalUsers={props.totalUsers}
							/>
						</Modal.Contents>

						<Modal.Footer />
					</Modal>
				</Popover>
			)}

			<AnalyticsConversationsMetricList
				metricGroupID={props.metricGroupID}
				metric={props.metric}
				totalUsers={props.totalUsers}
				limit={2}
			/>

			{props.metric.templates.length > 2 && (
				<AnalyticsConversationsMetricMore
					onClick={() => {
						setModalVisible(true);
					}}
				>
					{t('analytics.metrics.conversation.modal.openButton')}
				</AnalyticsConversationsMetricMore>
			)}
		</>
	);
}
